import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { mensajeEnTextoPlano, tieneHtml } from '@core/utils/mensaje-plano.util';

/**
 * El backend arma muchos mensajes con HTML heredado de la pantalla anterior («<p>Valores de campos no validos.</p><p><strong>Campo: </strong>…»).
 * Aquí, en un solo lugar, el `message` de toda respuesta JSON llega a los componentes en texto plano. Una respuesta sin HTML, sin `message`
 * o que no es un objeto JSON (un arreglo, un blob, un archivo) pasa sin tocar.
 */
export const mensajePlanoInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    map(evento => {
      if (!(evento instanceof HttpResponse)) return evento;
      const cuerpo = evento.body as unknown;
      if (!cuerpo || typeof cuerpo !== 'object' || Array.isArray(cuerpo) || (typeof Blob !== 'undefined' && cuerpo instanceof Blob)) return evento;
      const mensaje = (cuerpo as { message?: unknown }).message;
      if (typeof mensaje !== 'string' || !tieneHtml(mensaje)) return evento;
      return evento.clone({ body: { ...(cuerpo as object), message: mensajeEnTextoPlano(mensaje) } });
    }),
  );
